import React from 'react'
import PropTypes from 'prop-types'
import ImageFallback from 'Components/imagefallback/next_image'

const MaleDailyNavbar = ({ isMobile }) => {
  if (isMobile)
    return (
      <>
        <div className="maledaily-nav maledaily-nav--mobile">
          <a
            className="maledaily-nav__logo"
            href={process.env.NEXT_PUBLIC_ROOT_HOME}
          >
            <ImageFallback
              alt="Male Daily"
              src={process.env.NEXT_PUBLIC_MALE_DAILY_PAGE_LOGO}
              width={112}
              height={40}
              quality={100}
              fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
              objectFit="contain"
              priority
            />
          </a>
          <div className="maledaily-nav__menu">
            <a
              className="maledaily-nav__menu-item fd-body-md-regular"
              href={process.env.NEXT_PUBLIC_ROOT_HOME}
            >
              Homepage
            </a>
            <a
              className="maledaily-nav__menu-item fd-body-md-regular"
              href={process.env.NEXT_PUBLIC_ROOT_DOMAIN}
            >
              Articles
            </a>
            <a
              className="maledaily-nav__menu-item fd-body-md-regular"
              href={process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}
            >
              Reviews
            </a>
            <a
              className="maledaily-nav__instagram"
              href={process.env.NEXT_PUBLIC_FD_INSTAGRAM}
              target="_blank"
            >
              <div className="maledaily-nav__instagram-icon">
                <ImageFallback
                  alt="Instagram"
                  src={process.env.NEXT_PUBLIC_INSTAGRAM_LINE}
                  width={20}
                  height={20}
                  quality={100}
                  fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
                  objectFit="contain"
                  priority
                />
              </div>
            </a>
          </div>
        </div>

        <style jsx>
          {`
            .maledaily-nav a {
              text-decoration: none;
              color: white;
            }

            .maledaily-nav--mobile {
              padding: var(--space-20) var(--space-16) var(--space-8)
                var(--space-16);
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 20px;
              position: sticky;
              top: 0;
              z-index: 1;
              background-color: #13161a;
            }

            .maledaily-nav--mobile .maledaily-nav__menu {
              max-width: 400px;
              display: flex;
              align-items: center;
              gap: 40px;
              justify-content: space-between;
              height: 32px;
            }

            .maledaily-nav--mobile .maledaily-nav__instagram {
              display: flex;
            }

            .maledaily-nav__logo {
              width: 112px;
              height: 40px;
            }

            .maledaily-nav__instagram-icon {
              width: 20px;
              height: 20px;
            }
          `}
        </style>
      </>
    )

  return (
    <>
      <div className="maledaily-nav">
        <a
          className="maledaily-nav__logo"
          href={process.env.NEXT_PUBLIC_ROOT_HOME}
        >
          <ImageFallback
            alt="Male Daily"
            src={process.env.NEXT_PUBLIC_MALE_DAILY_PAGE_LOGO}
            width={112}
            height={40}
            quality={100}
            fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
            objectFit="contain"
            priority
          />
        </a>
        <div className="maledaily-nav__menu">
          <a
            className="maledaily-nav__menu-item fd-body-md-regular"
            href={process.env.NEXT_PUBLIC_ROOT_HOME}
          >
            Homepage
          </a>
          <a
            className="maledaily-nav__menu-item fd-body-md-regular"
            href={process.env.NEXT_PUBLIC_ROOT_DOMAIN}
          >
            Articles
          </a>
          <a
            className="maledaily-nav__menu-item fd-body-md-regular"
            href={process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}
          >
            Reviews
          </a>
        </div>
        <a
          className="maledaily-nav__instagram fd-body-md-regular"
          href={process.env.NEXT_PUBLIC_FD_INSTAGRAM}
          target="_blank"
        >
          <span>Follow our social media</span>
          <div className="maledaily-nav__instagram-icon">
            <ImageFallback
              alt="Instagram"
              src={process.env.NEXT_PUBLIC_INSTAGRAM_LINE}
              width={20}
              height={20}
              quality={100}
              fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
              objectFit="contain"
              priority
            />
          </div>
        </a>
      </div>

      <style jsx>
        {`
          .maledaily-nav a {
            text-decoration: none;
            color: white;
          }

          .maledaily-nav {
            position: sticky;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1;
            padding: var(--space-20) var(--space-64);
            display: flex;
            gap: 20px;
            align-items: center;
            justify-content: space-between;
            background-color: #13161a;
          }

          .maledaily-nav__menu {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 40px;
          }

          .maledaily-nav__menu-item:hover {
            text-decoration: underline;
          }

          .maledaily-nav__instagram {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .maledaily-nav__logo {
            width: 112px;
            height: 40px;
          }

          .maledaily-nav__instagram-icon {
            width: 20px;
            height: 20px;
          }
        `}
      </style>
    </>
  )
}

MaleDailyNavbar.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyNavbar
